<template>

	<div class="main-contents">
		<div class="package">
			<div class="table">
				<div class="list-box">
					<div class="tit">
						전체 프로젝트
						<!-- <p class="sub_tit"><span>프로젝트 담당자께서 등록한 전체 프로젝트</span></p> -->
					</div>
					<div class="filter">
						<div>
							<div class="search-box">
								<div style="
								display: inline-flex;
								position: relative;
								padding: 2px 15px;
							    border: 1px solid #D6D7D8;
								border-radius: 25px;
								background: #fff;
								">
									<SelectComp type="select" title="승인 상태" list="1:미승인,2:승인" :isAll="true" v-model="input.projectApprStatus" @change="projectApprStatusCheck(input.projectApprStatus)"/><nbsp/>
									<SelectComp type="select" title="프로젝트 상태" list="2:수행예정,1:수행중,9:완료" :isAll="true" v-model="tmpProjectStatus" :disabled="projectAppYn"/><nbsp/>
									<InputComp type="text" placeholder="프로젝트명" v-model="input.searchKeyword" @keyup.enter="getList('1')"  />
									<div class="search_btn" @click="getList('1')">
										<img class="search" src="/images/icon_srch.png" alt="검색버튼"/>
									</div>
								</div>
							</div>
						
							<div class="filter_box">
								<ul>
									<li><img :class="input.orderGubun == '1' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('1')">등록일 순</p><span>ㅣ</span></li>
									<li><img :class="input.orderGubun == '5' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('5')">개발기간 긴 순</p><span>ㅣ</span></li>
									<li><img :class="input.orderGubun == '4' ? 'filter' : ''" src="/images/icon_filter.png" alt="필터"/><p @click="orderSearch('4')">개발기간 짧은 순</p></li>
								</ul>
							</div>
							<div class="prj-regist-btn">
								<div>
									<button type="button" @click="$router.push({name: 'PRJ301M02'})">프로젝트 등록</button>
								</div>
							</div>
						</div>
					</div>
			

					<!-- 전체프로젝트 리스트 -->
					<div class="Board type3">
						<table class="Board_type3 prj list-all" style="margin-left: 0;">
							<colgroup>
								<col width="4%">
								<col width="*">
								<col width="16%">
								<col width="8%">
								<col width="10%">
								<col width="15%">
							</colgroup>
						
							<thead>
								<tr>
									<th>NO</th>
									<th>프로젝트명</th>
									<th>프로젝트 기간</th>
									<th>등록일</th>
									<th>프로젝트 상태</th>
									<th>일반 프로젝트</th>
								</tr>
								
							</thead>
							<tbody>
								<tr v-for="(project, index) in projectList" :key="project.projectSeq">
									<td class="score">{{ (pageInfo.pageIndex - 1) * pageInfo.pageUnit + (index + 1)}}</td>
									<td class="score prj-name ta-left">
									<div style="display: flex; justify-content: space-between; align-items: center; margin: 0 10px;">
										<div class="rc_tag ta-center" >
											<div v-if="project.apprYn != 'Y'" class="rc_mark_red">미승인</div>
											<div v-else-if="project.recrEndDateDiff >= 0" class="rc_mark">모집중</div>
										</div>
										<div :class="project.apprYn != 'Y'? 'project pt-1':'project'">{{project.projectNm}}</div>
    									<div class="btn" style="minWidth: 98px" @click="edit_deleteProject(project.projectSeq)">
        									수정/삭제 &#9654;
    									</div>
									</div>
									</td>
									<td class="score">{{project.projectStartEndYyyymmdd}}</td>
									<td class="score">{{project.regDate | date('yyyy.MM.dd')}}</td>
									
									
									<td class="score">
										<span v-if="project.apprYn != 'Y'">-</span>
										<span v-else-if="project.projectStatus == 1"><div class="state pf"></div>수행중</span>
										<span v-else-if="project.projectStatus == 2"><div class="state ep"></div>수행예정</span>
										<span v-else-if="project.projectStatus == 9"><div class="state cp"></div>수행완료</span>
									</td>
									
									<td class="score resume">
										<div class="btn" v-if="project.apprYn != 'N'" style="min-width: 110px;" @click="clickProjectDetail(project)">프로젝트 보기 &#9654;</div>
										<div v-else style="min-width: 110px;">-</div>
									</td>
								</tr>	
								<!-- 등록된 프로젝트가 없을 경우 -->
								<tr v-if="pageInfo.totalRecordCount == 0">
									<td colspan="6" class="none">등록된 프로젝트가 없습니다.</td>
								</tr>
							</tbody>
						</table>
					</div>
					
					<!--페이징 컴포넌트 -->
					<PagingComp :pageInfo="pageInfo" @page-click="goPage"/>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

import PagingComp from '@/components/PagingComp.vue';

export default {

	components : {
		PagingComp
	},

	data() {
		return {
			input: {
				pageIndex : '1',
				orderGubun : '1',	// 1:등록일 순, 2:참여인재 많은 순, 3:참여인재 적은 순
				searchGubun : '1',	// 1:프로젝트명, 2:담당자명
				searchKeyword : '',
				projectStatus : []
			}, // 검색조건		
			projectList : [],
			pageInfo : {},
			tmpProjectStatus:'',
			projectAppYn : false,
			
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');
	},
	mounted() {
		// console.log('mounted');
		if(this.$route.params != undefined && this.$route.params.pageIndex != undefined) {
			this.input = this.$route.params;
		}

		this.getList();
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		getList(div) {
			if(div) this.input.pageIndex = 1;

			this.input.projectStatus =[];

			if(this.tmpProjectStatus != ''){
				this.input.projectStatus.push(this.tmpProjectStatus);
			}

			this.$.httpPost('/api/prj/dco/gmg/getTotalProjectList', this.input)
				.then(res => {
					// console.log(res.data);
					this.projectList = res.data.list;
					this.pageInfo = res.data.pageInfo;
					
					window.scroll(0, 0);
				})
				.catch(err => {
					// console.log('============================='); 
					// console.log(err);
					// console.log(err.response);
					// console.log('============================='); 

					alert(err.response.data.error_description);
				});
		},

		goPage(page) {
			// console.log(page);
			this.input.pageIndex = page;
			this.getList();
		},

		orderSearch(orderGubun) {
			this.input.orderGubun = orderGubun;
			this.input.pageIndex = 1;
			this.getList();
		},		

		// clickProjectInfo(projectSeq) {
		// 	// this.$router.push({name : 'PRJ201M02', params : {projectSeq : projectSeq, caller : { name : 'PRJ201M01', params :this.input}}});
		// 	this.$router.push({name : 'PRJ201M02', query : {projectSeq : projectSeq}, params : {caller : { name : 'PRJ201M01', params :this.input}}});
		// },

		// clickChangeCorpMgrMberNm(projectSeq, projectNm) {
		// 	var param = {
		// 		projectSeq : projectSeq,
		// 		projectNm : projectNm,
		// 	};
		// 	this.$.popup('/dco/gmg/prj/PRJ201P01', param, {width:0, height:0})
		// 		.then(() => {
		// 			this.getList();
		// 		})
		// 		// .catch(err => {})
		// 		;
		// },

		// mberPopup(seq) {
		// 	var div = 'dco';
		// 	this.$.popup('/dco/gmg/myp/MYP201P01', { seq, div });
		// },
		projectApprStatusCheck(val) {
			if(val == 1) {
				this.projectAppYn = true;
				this.tmpProjectStatus = '';
			} else {
				this.projectAppYn = false;
			}
		},
		clickProjectDetail(val) {
			if(val.recrEndDateDiff >= 0) {
				this.$router.push({name : 'PRJ302M04', params : { srchName : val.projectNm, caller : { name : this.$route.name, params :this.input}}});
			} else {
				switch(val.projectStatus) {
						// 4:제안단계,2:수행예정,1:수행중,9:완료
						// 30204  30205  30202  30201  30203
						case '2' : this.$router.push({name : 'PRJ302M02', params : { srchName : val.projectNm, caller : { name : this.$route.name, params :this.input}}}); break;
						case '1' : this.$router.push({name : 'PRJ302M01', params : { srchName : val.projectNm, caller : { name : this.$route.name, params :this.input}}}); break;
						case '9' : this.$router.push({name : 'PRJ302M03', params : { srchName : val.projectNm, caller : { name : this.$route.name, params :this.input}}}); break;
							
					}
			}
		},


    	edit_deleteProject(projectSeq) {
    		// 프로젝트 수정 화면으로 이동
        	this.$router.push({ name: 'PRJ303M03', query: { projectSeq: projectSeq } });
    },
    	

	},
	// computed : {
	// 	mberDiv() {
	// 		// 수요 Y 관리총괄 N
	// 		if(this.$store.state.userInfo.mberDivCd == '22') return true
	// 		return false;
	// 	}
	// }

};
</script>
